import React from 'react';
import HeroAnimatedV3 from '../components/landing/HeroAnimatedV3';

/**
 * LexyLandingWhite - World-class animated landing page with storytelling
 */
const LexyLandingWhite = () => {
  return <HeroAnimatedV3 />;
};

export default LexyLandingWhite;
